import { PiPlaceholder } from "react-icons/pi";
import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons";
export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "eSanchitInvsrNo",
            label: "Invoice Sr. No",
            component: "text-field",
             type: "autocomplete",
            endpoint: "getESanchitInvoiceQuery",
            icon: LuSearch,
            placeholder: "[#0001] SL0/25020297",
          },
          {
            name: "eSanchitItemSrNo",
            label: "Item Sr. No.",
            component: "text-field",
            icon: LuSearch,
            type: "autocomplete",
            endpoint: "getDescription",
            placeholder: "[#0002] CENTRIFUGAL...",
          },
        ],
        row2: [
          {
            name: "eSanchitDocumentType",
            label: "Document Type",
            component: "text-field",
            type : "autocomplete",
            endpoint : "getESanchitDocument",
            placeholder: "911DA2-Airoperator Permit (Non-Scheduled)",
          },
        ],
        row3: [
          {
            name: "eSanchitOtherIcegateId",
            label: "ICEGATE ID",
            component: "dropdown",
            endIconName: LuChevronDown,
            options: [
              {
                label: "AAGCR9244LPSU00 - FCard - admin",
                value: "AAGCR9244LPSU00",
              },
              {
                label: "AAHCA3430APSU00 - FCard - Avalon",
                value: "AAHCA3430APSU00",
              },
              {
                label: "AAPCS7948KPSU00 - FCard - admin",
                value: "AAPCS7948KPSU00",
              },
              {
                label: "AAPCS7948KPSU02 - FCard - admin",
                value: "AAPCS7948KPSU02",
              },
              {
                label: "ARUNKUMBHARE1973 - GCard - ARUNKUMBHARE1973",
                value: "ARUNKUMBHARE1973",
              },
              {
                label: "BLRTRIPATHI - FCard - BLRTRIPATHI",
                value: "BLRTRIPATHI",
              },
              { label: "BOMTRIPATH - FCard - BOMTRIPATH", value: "BOMTRIPATH" },
              { label: "DELTRIPATH - FCard - DELTRIPATH", value: "DELTRIPATH" },
              {
                label: "HPPPSEZZAIR - FCard - HPPPSEZZAIR",
                value: "HPPPSEZZAIR",
              },
              { label: "HPPPSEZCHA - FCard - HPPPSEZCHA", value: "HPPPSEZCHA" },
              {
                label: "SANDESHGORULE1987 - GCard - SANDESHGORULE1987",
                value: "SANDESHGORULE1987",
              },
              { label: "TRIPATHAMD - GCard - TRIPATHAMD", value: "TRIPATHAMD" },
              { label: "TRIPATHBLR - FCard - TRIPATHBLR", value: "TRIPATHBLR" },
              {
                label: "TRIPATHBLR1 - GCard - TRIPATHBLR1",
                value: "TRIPATHBLR1",
              },
              {
                label: "TRIPATHBLR2 - FCard - TRIPATHBLR2",
                value: "TRIPATHBLR2",
              },
              {
                label: "TRIPATHCCU123 - GCard - TRIPATHCCU123",
                value: "TRIPATHCCU123",
              },
              { label: "TRIPATHHYD - FCard - TRIPATHHYD", value: "TRIPATHHYD" },
              { label: "TRIPATHMAA - FCard - TRIPATHMAA", value: "TRIPATHMAA" },
              { label: "Other", value: "Other" },
            ],
            placeholder: "TRIPATHBLR1",
          },
          {
            name: "eSanchitIRN",
            label: "IRN",
            component: "text-field",
            placeholder: "2025072400120647",
          },
        ],
        row4: [
          {
            name: "eSanchitDocumentRefNo",
            label: "Document Ref.No.",
            component: "text-field",
            width: "50%",
            placeholder: "SL0/25020297",
          },
        ],
      },
    },
  ],
};
